import PreferencesTable from './preferences-table.connect'

export default PreferencesTable
